




























































import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { StringMap } from '@/shared/utils/map'
import { loggerFor } from '@/shared/utils/logger'
import { TypedForm } from '@/shared/forms/typed-form'
import { htmlToText } from '@/shared/utils/html-to-text'

@Component({
  inject: ['form'],
})
export default class RespondecoValidationFeedback extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly control!: string

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly validatePristine!: boolean

  public readonly form!: TypedForm<any, any>

  private logger = loggerFor('ValidationFeedback')

  get dirty() {
    return this.validatePristine === true || this.state.$dirty
  }

  get error(): boolean {
    return this.state.$error
  }

  get model(): string {
    return this.state.$model
  }

  get state() {
    return this.form.field(this.control)
  }

  public htmlLength(model: string): number {
    return htmlToText(model).length
  }

  /**
   * Check if the given validator has been defined and is currently invalid
   */
  public is(validatorName: string): boolean {
    let returnValue = false

    let state: boolean | undefined

    if (validatorName in this.state) {
      state = this.state[validatorName]
    }

    // Validator is defined for this control
    if (state !== undefined) {
      // The validator value will be true if the validation rule is valid
      returnValue = !state

      if (returnValue) {
        this.logger.warn(validatorName, this.state)
      }
    }

    return returnValue
  }

  /**
   * Get the Vuelidate parameter for the given validator or an empty object it isn't defined
   * @param validatorName
   */
  public params(validatorName: string): StringMap<any> {
    const params: StringMap<any> = this.state.$params[validatorName]

    return params || {}
  }
}
